import React from 'react';
import { Helmet } from "react-helmet-async";

const SEO = ({ pageTitle }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle} - Redação Online Pricilla Záttera</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="Redação com correção online muito detalhada e específica (de acordo com os critérios de cada Banca), venha aprender a escrever uma redação de forma correta." />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Helmet>
    </>
  );
};

export default SEO;